import { Injectable, OnDestroy } from '@angular/core';
import { BehaviorSubject, Subscription } from 'rxjs';
import { doc, docData, Firestore } from '@angular/fire/firestore';
import { traceUntilFirst } from '@angular/fire/performance';

import { AdminSettings } from '../models/admin-settings.model';

@Injectable({
  providedIn: 'root'
})
export class AdminSettingsService implements OnDestroy {
  private hasSettings$ = new BehaviorSubject<boolean>(false);
  private settings$ = new BehaviorSubject<AdminSettings | null>(null);
  private settings: AdminSettings | null = null;
  private subscription: Subscription | null = null;

  constructor(
    private firestore: Firestore,
  ) { }

  ngOnDestroy(): void {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }

  public ready() {
    return this.hasSettings$;
  }

  public getSettings$() {
    return this.settings$.asObservable();
  }

  public getSettings() {
    return this.settings;
  }

  public async load() {
    this.subscription?.unsubscribe();
    this.subscription = null;

    const ref = doc(this.firestore, 'settings/admin');

    this.subscription = docData(ref).pipe(
      traceUntilFirst('firestore')
    ).
      subscribe((res: any) => {
        if (res) {
          this.hasSettings$.next(true);
          this.settings$.next(res);
          this.settings = res;
        } else {
          console.error('We are unable to connect to the search index, configuration could not be loaded.');
          this.hasSettings$.next(false);
        }
      });
  }

  public reset(): void {
    this.subscription?.unsubscribe();
    this.subscription = null;
    this.settings = null;
    this.settings$.next(null);
    this.hasSettings$.next(false);
  }
}
